import { ICompany } from 'app/shared/model/company.model';
import { PlaceTypeEnum } from 'app/shared/model/enumerations/place-type-enum.model';

export interface IPlace {
  id?: number;
  name?: string | null;
  type?: PlaceTypeEnum | null;
  placeId?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  approved?: boolean | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IPlace> = {
  approved: false,
};
